import { useState, useCallback } from 'react';

interface Notification {
  id: string;
  type: 'comment' | 'like' | 'follow' | 'mention' | 'article' | 'video';
  title: string;
  description: string;
  user: {
    name: string;
    avatar: string;
  };
  createdAt: Date;
  read: boolean;
  link: string;
}

// Mock notifications for demonstration
const mockNotifications: Notification[] = [
  {
    id: '1',
    type: 'comment',
    title: 'New Comment',
    description: 'Sarah commented on your article "The Future of AI"',
    user: {
      name: 'Sarah Mitchell',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150'
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 5), // 5 minutes ago
    read: false,
    link: '/article/1#comments'
  },
  {
    id: '2',
    type: 'like',
    title: 'Post Liked',
    description: 'Alex liked your post about machine learning trends',
    user: {
      name: 'Alex Chen',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150'
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 30), // 30 minutes ago
    read: true,
    link: '/post/2'
  },
  {
    id: '3',
    type: 'follow',
    title: 'New Follower',
    description: 'Emma started following you',
    user: {
      name: 'Emma Wilson',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150'
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 60), // 1 hour ago
    read: false,
    link: '/profile/emma'
  }
];

export function useNotifications() {
  const [notifications, setNotifications] = useState<Notification[]>(mockNotifications);

  const markAsRead = useCallback((id: string) => {
    setNotifications(prev =>
      prev.map(notification =>
        notification.id === id
          ? { ...notification, read: true }
          : notification
      )
    );
  }, []);

  const markAllAsRead = useCallback(() => {
    setNotifications(prev =>
      prev.map(notification => ({ ...notification, read: true }))
    );
  }, []);

  const unreadCount = notifications.filter(n => !n.read).length;

  return {
    notifications,
    unreadCount,
    markAsRead,
    markAllAsRead
  };
}